import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.test';
import { FormGroup } from '@angular/forms';
import { Apollo, MutationResult } from 'apollo-angular';
import {
  EconomicNatureIn,
  GetEconomicNatureByIdDocument,
  GetEconomicNatureByIdQuery,
  GetEconomicNatureCatalogsDocument,
  GetEconomicNatureCatalogsQuery,
  SaveEconomicNatureDocument,
  SaveEconomicNatureMutation,
  SaveEconomicNatureMutationVariables,
} from 'src/app/graphql/types';
import { ApolloQueryResult } from '@apollo/client/core';

@Injectable({
  providedIn: 'root',
})
export class EconomicNatureService {
  private readonly apollo = inject(Apollo);

  private endpoint = environment.IDEMPIER_GATEWAY + '/v1/economicnature';
  private http = inject(HttpClient);

  get(id: number): Observable<ApolloQueryResult<GetEconomicNatureByIdQuery>> {
    return this.apollo.watchQuery<GetEconomicNatureByIdQuery>({
      query: GetEconomicNatureByIdDocument,
      variables: {
        businessUnitId: id,
      },
    }).valueChanges;
  }

  save(
    form: FormGroup,
  ): Observable<MutationResult<SaveEconomicNatureMutation>> {
    return this.apollo.mutate<
      SaveEconomicNatureMutation,
      SaveEconomicNatureMutationVariables
    >({
      mutation: SaveEconomicNatureDocument,
      variables: {
        json: this.economicNatureIn(form),
      },
    });
  }

  getCatalogs(): Observable<ApolloQueryResult<GetEconomicNatureCatalogsQuery>> {
    return this.apollo.watchQuery<GetEconomicNatureCatalogsQuery>({
      query: GetEconomicNatureCatalogsDocument,
    }).valueChanges;
  }

  private economicNatureIn(form: FormGroup): EconomicNatureIn {
    return {
      businessUnitId: form.get('id')?.value,
      architecture: {
        id: form.get('architecture')?.value,
      },
      prototype: {
        id: form.get('prototype')?.value,
      },
      sector: {
        id: form.get('sector')?.value,
      },
      banking: Number(form.get('bancking')?.value),
    };
  }
}
